import axios from 'axios';

export const http = axios.create({
    //baseURL: 'https://localhost:44394/api/'
    //baseURL: 'http://192.168.11.30:7985/api/'
    baseURL: 'https://pnldlivrodigital.editoradobrasil.com.br/api/api/'
})